import { ReactiveVar } from '@apollo/client'
import { GridApi } from 'ag-grid-community'
import IconRemoveThisColumn from 'assets/icons/context-menu/remove-this-column.svg'

export const removeColumn = (gridApi: GridApi, colId: string, closeMenuVar: ReactiveVar<any>) => {
  return {
    icon: IconRemoveThisColumn,
    content: 'Remove This Column',
    onClick: () => {
      closeMenuVar(false)
      return gridApi?.setColumnsVisible([colId], false)
    },
  }
}
